module.exports={
  "sf-bay": {
    "key": "sf-bay",
    "label": "San Francisco Bay",
    "lat_long": "37.48590175370924, -122.10224024969907",
    "mobile_lat_long": "37.591024329469434, -122.21103897145586",
    "classNames": "water-label",
    "notes": "",
    "label_width": -1,
    "old_alt_lat_long": "37.45884812846882, -122.07124095939969"
  },
  "facebook": {
    "key": "facebook",
    "label": "Facebook",
    "lat_long": "37.506871448023716, -122.1572761507481",
    "mobile_lat_long": "",
    "classNames": "place-label, facebook, company",
    "notes": "",
    "label_width": 200
  },
  "google": {
    "key": "google",
    "label": "Google",
    "lat_long": "37.44769474122401, -122.04478307488134",
    "mobile_lat_long": "",
    "classNames": "place-label, google, company",
    "notes": "",
    "label_width": 150
  },
  "facebook-big": {
    "key": "facebook-big",
    "label": "Facebook",
    "lat_long": "37.49135346665414, -122.15760650495187",
    "mobile_lat_long": "",
    "classNames": "place-label, facebook, company, big",
    "notes": "",
    "label_width": 300
  },
  "google-big": {
    "key": "google-big",
    "label": "Google",
    "lat_long": "37.43498158091634, -122.05467802831049",
    "mobile_lat_long": "",
    "classNames": "place-label, google, company, big",
    "notes": "",
    "label_width": 225
  },
  "d-bridge": {
    "key": "d-bridge",
    "label": "Dumbarton Bridge",
    "lat_long": "37.504987577874125, -122.11999375401957",
    "mobile_lat_long": "",
    "classNames": "bridge",
    "notes": "may not need?",
    "label_width": 150
  },
  "epa": {
    "key": "epa",
    "label": "East Palo Alto",
    "lat_long": "37.468259194379925, -122.13634396782516",
    "mobile_lat_long": "",
    "classNames": "place-label, special",
    "notes": "",
    "label_width": 150
  },
  "bh": {
    "key": "bh",
    "label": "Belle Haven",
    "lat_long": "37.47595669673022, -122.15960408531224",
    "mobile_lat_long": "",
    "classNames": "place-label, special",
    "notes": "",
    "label_width": 150
  },
  "palo-alto": {
    "key": "palo-alto",
    "label": "Palo Alto",
    "lat_long": "37.44158026250598, -122.14228614068362",
    "mobile_lat_long": "",
    "classNames": "place-label, town",
    "notes": "",
    "label_width": -1
  },
  "mountain-view": {
    "key": "mountain-view",
    "label": "Mountain View",
    "lat_long": "37.40690123392837, -122.0964937227728",
    "mobile_lat_long": "37.396115372058944, -122.08437249161119",
    "classNames": "place-label, town",
    "notes": "",
    "label_width": -1
  },
  "sunnyvale": {
    "key": "sunnyvale",
    "label": "Sunnyvale",
    "lat_long": "37.402152688093885, -122.00443004571143",
    "mobile_lat_long": "37.3802373901645, -122.02616750070707",
    "classNames": "place-label, town",
    "notes": "",
    "label_width": -1
  },
  "san-jose": {
    "key": "san-jose",
    "label": "San Jose",
    "lat_long": "37.36930182806396, -121.89792021976596",
    "mobile_lat_long": "",
    "classNames": "place-label, town",
    "notes": "",
    "label_width": -1
  },
  "fremont": {
    "key": "fremont",
    "label": "Fremont",
    "lat_long": "37.546837805658626, -122.0000876955807",
    "mobile_lat_long": "37.54897421271542, -122.02790108011905",
    "classNames": "place-label, town",
    "notes": "",
    "label_width": -1
  },
  "redwood-city": {
    "key": "redwood-city",
    "label": "Redwood City",
    "lat_long": "37.47890039768633, -122.26922956590475",
    "mobile_lat_long": "hide",
    "classNames": "place-label, town",
    "notes": "",
    "label_width": -1
  },
  "hayward": {
    "key": "hayward",
    "label": "Hayward",
    "lat_long": "37.630692271165316, -122.07988094242559",
    "mobile_lat_long": "",
    "classNames": "place-label, town",
    "notes": "",
    "label_width": -1
  },
  "cupertino": {
    "key": "cupertino",
    "label": "Cupertino",
    "lat_long": "37.32269319190995, -122.03858614426588",
    "mobile_lat_long": "",
    "classNames": "place-label, town",
    "notes": "",
    "label_width": -1
  },
  "menlo-park": {
    "key": "menlo-park",
    "label": "Menlo Park",
    "lat_long": "37.459645222447556, -122.16096947536812",
    "mobile_lat_long": "37.45379113818839, -122.18792550199832",
    "classNames": "place-label, town",
    "notes": "",
    "label_width": -1
  },
  "sunnyvale-note": {
    "key": "sunnyvale-note",
    "label": "Sunnyvale campus",
    "lat_long": "37.40024056352013, -122.00382587613478",
    "mobile_lat_long": "",
    "classNames": "note, left",
    "notes": "",
    "label_width": 200
  },
  "mountain-view-note": {
    "key": "mountain-view-note",
    "label": "Original Mountain View campus",
    "lat_long": "37.41715143864056, -122.10435170786427",
    "mobile_lat_long": "",
    "classNames": "note, right",
    "notes": "",
    "label_width": 200
  },
  "facebook-original-note": {
    "key": "facebook-original-note",
    "label": "Original Facebook campus",
    "lat_long": "37.48531320833388, -122.13013459708482",
    "mobile_lat_long": "",
    "classNames": "note, left",
    "notes": "",
    "label_width": 200
  },
  "facebook-new-note": {
    "key": "facebook-new-note",
    "label": "Newer campus additions tk",
    "lat_long": "37.47807295043041, -122.1592560830214",
    "mobile_lat_long": "",
    "classNames": "note, bottom, right",
    "notes": "",
    "label_width": 200
  },
  "highway-101": {
    "key": "highway-101",
    "label": 101,
    "lat_long": "37.44851289363697, -122.12330995748268",
    "mobile_lat_long": "37.39137014586745, -121.99648013334345",
    "classNames": "highway-shield",
    "notes": "",
    "label_width": 20
  },
  "highway-84": {
    "key": "highway-84",
    "label": 84,
    "lat_long": "37.51124127196328, -122.11120134508865",
    "mobile_lat_long": "",
    "classNames": "highway-shield",
    "notes": "",
    "label_width": 20
  },
  "highway-880": {
    "key": "highway-880",
    "label": 880,
    "lat_long": "37.474019330162, -121.93098141285226",
    "mobile_lat_long": "37.582813030756725, -122.05058259696571",
    "classNames": "highway-shield, interstate",
    "notes": "",
    "label_width": 30
  },
  "highway-680": {
    "key": "highway-680",
    "label": 680,
    "lat_long": "37.49011871864202, -121.91866493046425",
    "mobile_lat_long": "",
    "classNames": "highway-shield, interstate",
    "notes": "",
    "label_width": 30
  },
  "highway-280": {
    "key": "highway-280",
    "label": 280,
    "lat_long": "37.398920603969884, -122.18144952415444",
    "mobile_lat_long": "37.38427056791199, -122.15512416831898",
    "classNames": "highway-shield, interstate",
    "notes": "",
    "label_width": 30
  }
}